import Cookies from 'js-cookie'

import { ActionTypes as AuthActions } from '../actions/authentication'
import { ActionTypes as PollingActions } from '../actions/polling'

const initialState = {}

export const tagmanager = (state = initialState, action) => {
  switch (action.type) {
    case PollingActions.POLLING_SUCCESS: {
      if (action.jobId !== 'create') {
        return state
      }
      // upload success - increase paper count
      return Object.assign({}, state, {
        userPaperCount: state.userPaperCount + 1,
      })
    }

    case AuthActions.AUTHENTICATION_LOGIN: {
      // eslint-disable-next-line no-param-reassign
      if (!action.user) action.user = {}
      const plan = action.user.cheggUserId ? action.user.userAccount.plan : 'not logged in'

      return Object.assign({}, initialState, {
        // stuff bibme sends with the initial load event (see also https://github.com/easybib/wpt/pull/982)
        user_id: action.user.cheggUserId || 'not logged in',
        user: plan,
        // stuff bibme sends with some other events
        userID: action.user.cheggUserId,
        loggedIn: action.user.isGuestUser ? 'no' : 'yes',
        accountMemberType: plan,
        // our stuff
        wptUserID: action.user.id,
        userPaperCount: action.user.paperCount,
        archieLeagueAdVersion: Cookies.get('ad_config_version'),
      })
    }

    case AuthActions.AUTHENTICATION_LOGOUT:
      return Object.assign({}, initialState)

    default:
      return state
  }
}

export default tagmanager
